<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="success"
        dark
        v-bind="attrs"
        v-on="on"
        @click="updateCertificates"
        v-if="false"
      >
        assinar
      </v-btn>

      <v-row align="center" dense v-else>
        <v-col cols="auto">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :disabled="false"
                :loading="printLoading"
                @click="downloadArchive"
                :attrs="attrs"
                v-on="on"
              >
                <v-icon>eva-printer-outline</v-icon>
              </v-btn>
            </template>
            <span> Imprimir Resumo Geral</span>
          </v-tooltip>
        </v-col>

        <!-- <v-col>
          <v-alert dense type="success" class="mb-0">
            Atendimento assinado
          </v-alert>
        </v-col> -->
      </v-row>
    </template>

    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>Assinatura digital</v-toolbar-title>
      </v-toolbar>

      <v-container fluid>
        <v-progress-linear
          indeterminate
          absolute
          top
          :active="signing"
          style="z-index: 10"
        />

        <v-overlay :value="loadingEsign || signing">
          <v-progress-circular indeterminate size="64" />
        </v-overlay>

        <v-row align="center">
          <v-col cols="9">
            <v-select
              label="Certificado"
              placeholder="Selecione um certificado"
              v-model="certificate"
              outlined
              dense
              :items="certificates"
              :item-text="
                (item) =>
                  `${item.subjectName} - (emitido por ${item.issuerName})`
              "
              item-value="thumbprint"
              :hide-details="errors.certificate === undefined"
              :error-messages="errors.certificate"
            />
          </v-col>

          <v-col>
            <v-btn block color="success" @click="sign" :disabled="signing">
              assinar
            </v-btn>
          </v-col>

          <v-col cols="auto">
            <v-btn block color="red" text @click="cancel" :disabled="signing">
              cancelar
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-divider />
          </v-col>
        </v-row>

        <v-row
          align="stretch"
          :style="{ height: '75vh', minHeight: '75vh', maxHeight: '75vh' }"
        >
          <v-col cols="3" :style="{ maxHeight: '100%' }">
            <v-row dense>
              <v-col class="text-h5 font-weight-bold"> Assinaturas </v-col>
            </v-row>

            <v-row dense :style="{ overflow: 'auto', maxHeight: '95%' }">
              <v-col>
                <v-row dense v-if="attendanceEsign">
                  <v-col>
                    <v-card
                      block
                      @click="changeCurrentEsign(attendanceEsign)"
                      :disabled="signing"
                    >
                      <v-container fluid>
                        <v-row dense align="center">
                          <v-col class="font-weight-bold"> Atendimento </v-col>

                          <v-col cols="auto">
                            <v-icon
                              color="red"
                              v-if="
                                attendanceEsign.lastEsign.status === 'editable'
                              "
                            >
                              eva-close-outline
                            </v-icon>
                            <v-icon color="green" v-else
                              >ri-check-double-line</v-icon
                            >
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row
                  dense
                  v-for="(esign, index) in surgeriesEsigns"
                  :key="esign.id"
                >
                  <v-col>
                    <v-card
                      block
                      @click="changeCurrentEsign(esign)"
                      :disabled="signing"
                    >
                      <v-container fluid>
                        <v-row dense align="center">
                          <v-col class="font-weight-bold">
                            Cirurgia {{ index + 1 }}
                          </v-col>

                          <v-col cols="auto">
                            <v-icon
                              color="red"
                              v-if="esign.lastEsign.status === 'editable'"
                            >
                              eva-close-outline
                            </v-icon>
                            <v-icon color="green" v-else
                              >ri-check-double-line</v-icon
                            >
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row
                  dense
                  v-for="(esign, index) in prescriptionsEsigns"
                  :key="esign.id"
                >
                  <v-col>
                    <v-card
                      block
                      @click="changeCurrentEsign(esign)"
                      :disabled="signing"
                    >
                      <v-container fluid>
                        <v-row dense align="center">
                          <v-col class="font-weight-bold">
                            Receita {{ index + 1 }}
                          </v-col>

                          <v-col cols="auto">
                            <v-icon
                              color="red"
                              v-if="esign.lastEsign.status === 'editable'"
                            >
                              eva-close-outline
                            </v-icon>
                            <v-icon color="green" v-else
                              >ri-check-double-line</v-icon
                            >
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row
                  dense
                  v-for="(esign, index) in glassesPrescriptionsEsigns"
                  :key="esign.id"
                >
                  <v-col>
                    <v-card
                      block
                      @click="changeCurrentEsign(esign)"
                      :disabled="signing"
                    >
                      <v-container fluid>
                        <v-row dense align="center">
                          <v-col class="font-weight-bold">
                            Receita de óculos {{ index + 1 }}
                          </v-col>

                          <v-col cols="auto">
                            <v-icon
                              color="red"
                              v-if="esign.lastEsign.status === 'editable'"
                            >
                              eva-close-outline
                            </v-icon>
                            <v-icon color="green" v-else
                              >ri-check-double-line</v-icon
                            >
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row
                  dense
                  v-for="(esign, index) in medicalCertificatesEsigns"
                  :key="esign.id"
                >
                  <v-col>
                    <v-card
                      block
                      @click="changeCurrentEsign(esign)"
                      :disabled="signing"
                    >
                      <v-container fluid>
                        <v-row dense align="center">
                          <v-col class="font-weight-bold">
                            Atestado {{ index + 1 }}
                          </v-col>

                          <v-col cols="auto">
                            <v-icon
                              color="red"
                              v-if="esign.lastEsign.status === 'editable'"
                            >
                              eva-close-outline
                            </v-icon>
                            <v-icon color="green" v-else
                              >ri-check-double-line</v-icon
                            >
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col :style="{ height: '100%' }">
            <object
              :data="fileUrl"
              type="application/pdf"
              width="100%"
              height="100%"
            >
              <embed :src="fileUrl" type="application/pdf" />
            </object>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AttendanceEsign",
  props: {
    attendance: Object,
    vDialog: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: () => {},
    },
  },
  model: {
    prop: "vDialog",
    event: "change",
  },
  data() {
    return {
      errors: {},
      certificates: [],
      certificate: "",
      Idialog: false,
      signing: false,
      currentEsing: null,
      printLoading: null,
    };
  },
  mounted() {
    this.updateCertificates();
  },
  apollo: {
    attendanceEsign: {
      query: require("@/graphql/attendance/esign_dependencies.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
      update: (data) => data.attendance,
      result() {
        this.currentEsing = this.attendanceEsign;
      },
      fetchPolicy: "no-cache",
      pollInterval: 20000,
    },
  },
  computed: {
    dialog: {
      set(value) {
        this.Idialog = value;
        this.$emit("change", value);
      },
      get() {
        return this.vDialog || this.Idialog;
      },
    },
    fileUrl() {
      if (this.currentEsing) {
        return `${process.env.VUE_APP_BASE_URL}${this.currentEsing.lastEsign.fileUrl}`;
      }

      return "";
    },
    showButton() {
      let status = this.attendance.lastEsign.status !== "signed";
      if (this.attendanceEsign) {
        status = this.attendanceEsign.lastEsign.status !== "signed";
      }

      return status;
    },
    loadingEsign() {
      return this.$apollo.queries.attendanceEsign.loading;
    },
    surgeriesEsigns() {
      if (!this.attendanceEsign) return [];
      return this.attendanceEsign.surgeries;
    },
    prescriptionsEsigns() {
      if (!this.attendanceEsign) return [];
      return this.attendanceEsign.prescriptions;
    },
    glassesPrescriptionsEsigns() {
      if (!this.attendanceEsign) return [];
      return this.attendanceEsign.glassesPrescriptions;
    },
    medicalCertificatesEsigns() {
      if (!this.attendanceEsign) return [];
      return this.attendanceEsign.medicalCertificates;
    },
    allEsigns() {
      if (!this.attendanceEsign) return [];
      let allEsigns = [];
      allEsigns.push(this.attendanceEsign.lastEsign);
      allEsigns = allEsigns.concat(
        this.surgeriesEsigns.map((e) => e.lastEsign)
      );
      allEsigns = allEsigns.concat(
        this.prescriptionsEsigns.map((e) => e.lastEsign)
      );
      allEsigns = allEsigns.concat(
        this.glassesPrescriptionsEsigns.map((e) => e.lastEsign)
      );
      allEsigns = allEsigns.concat(
        this.medicalCertificatesEsigns.map((e) => e.lastEsign)
      );

      return allEsigns;
    },
    waitingEsign() {
      return this.lodash.filter(this.allEsigns, (e) => e.status !== "signed");
    },
  },
  methods: {
    changeCurrentEsign(esign) {
      this.currentEsing = esign;
    },
    cancel() {
      this.dialog = false;
    },
    async updateCertificates() {
      await this.refetchEsign();

      this.$lacuna.listCertificates().success((certs) => {
        this.certificates = certs;
      });
    },
    async refetchEsign() {
      await this.$apollo.queries.attendanceEsign.refetch();
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      if (!this.certificate) {
        this.errors.certificate = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
    sign() {
      if (!this.validate()) return;

      if (this.lodash.isEmpty(this.waitingEsign)) return;
      this.signing = true;

      Promise.all(this.getEsignTokens()).then((responses) => {
        this.lacunaPreauthorize({ responsesLength: responses.length }).success(
          () => {
            this.finishEsings(responses);
          }
        );
      });
    },
    getEsignTokens() {
      return this.waitingEsign.map((esign) => {
        return this.apolloMutate({
          mutation: require("@/graphql/esign/generate_bytes_to_sign.gql"),
          variables: {
            esignId: esign.id,
          },
        });
      });
    },
    lacunaPreauthorize({ responsesLength }) {
      return this.$lacuna.preauthorizeSignatures({
        certificateThumbprint: this.certificate,
        signatureCount: responsesLength,
      });
    },
    esignToken({ bytesToSign }) {
      return this.$lacuna.signWithRestPki({
        thumbprint: this.certificate,
        token: bytesToSign,
      });
    },
    finishEsings(responses) {
      responses.map(({ data }) => {
        const bytesToSign = data.generateBytesToSign.token;
        const esignId = data.generateBytesToSign.id;

        return this.esignToken({ bytesToSign: bytesToSign })
          .success((signature) => {
            this.apolloMutate({
              mutation: require("@/graphql/esign/finish_signature.gql"),
              variables: {
                esignId: esignId,
                token: signature,
              },
            })
              .then(() => {
                this.signing = false;
                this.dialog = false;

                this.refetchEsign();
                this.callback();

                this.$store.dispatch("createNotification", {
                  message: "Assinaturas realizadas.",
                  type: "success",
                });
              })
              .finally(() => {
                this.signing = false;
              });
          })
          .fail((error) => {
            console.error(error);
            this.signing = false;
          });
      });
    },
    async generatePreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.attendanceEsign.lastEsign.id,
          dynamicForm: true,
          examAppraisal: true,
        },
      });
    },
    async downloadArchive() {
      this.printLoading = true;
      await this.generatePreview();
      await this.refetchEsign();
      const file_url = this.attendanceEsign.lastEsign.fileUrl;
      await window.open(`${process.env.VUE_APP_BASE_URL}${file_url}`, "_blank");
      // } else {
      //   this.$store.dispatch("createNotification", {
      //     message: "É necessário assinar antes de imprimir.",
      //     type: "error",
      //   });
      // }

      this.printLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
